module.exports = __webpack_public_path__ + "img/member_list_4.b92a4dd3.png";